/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExpressionCCL
 */
export interface ExpressionCCL {
    /**
     * 
     * @type {number}
     * @memberof ExpressionCCL
     */
    expressionCclId?: number;
    /**
     * 
     * @type {number}
     * @memberof ExpressionCCL
     */
    conclusionGroupId?: number;
    /**
     * 
     * @type {number}
     * @memberof ExpressionCCL
     */
    expressionId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ExpressionCCL
     */
    isMarked?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ExpressionCCL
     */
    expressionOrder?: number;
}

/**
 * Check if a given object implements the ExpressionCCL interface.
 */
export function instanceOfExpressionCCL(value: object): value is ExpressionCCL {
    return true;
}

export function ExpressionCCLFromJSON(json: any): ExpressionCCL {
    return ExpressionCCLFromJSONTyped(json, false);
}

export function ExpressionCCLFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpressionCCL {
    if (json == null) {
        return json;
    }
    return {
        
        'expressionCclId': json['expressionCclId'] == null ? undefined : json['expressionCclId'],
        'conclusionGroupId': json['conclusionGroupId'] == null ? undefined : json['conclusionGroupId'],
        'expressionId': json['expressionId'] == null ? undefined : json['expressionId'],
        'isMarked': json['isMarked'] == null ? undefined : json['isMarked'],
        'expressionOrder': json['expressionOrder'] == null ? undefined : json['expressionOrder'],
    };
}

export function ExpressionCCLToJSON(json: any): ExpressionCCL {
    return ExpressionCCLToJSONTyped(json, false);
}

export function ExpressionCCLToJSONTyped(value?: ExpressionCCL | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expressionCclId': value['expressionCclId'],
        'conclusionGroupId': value['conclusionGroupId'],
        'expressionId': value['expressionId'],
        'isMarked': value['isMarked'],
        'expressionOrder': value['expressionOrder'],
    };
}

